import { Helmet } from 'react-helmet';
import React from 'react';

const ENV = process.env.REACT_APP_ENV as
  | 'PRODUCTION'
  | 'STAGING'
  | 'DEVELOPMENT'
  | undefined;

const GTM_IDS: Record<string, string> = {
  PRODUCTION: 'GTM-T9PWBRCX',
  STAGING: 'GTM-PFBFKGRX',
  DEVELOPMENT: 'GTM-PFBFKGRX',
};

const gtmId = (ENV && GTM_IDS[ENV]) || undefined;

const GTM: React.FC = () => {
  if (!gtmId) return null;

  return (
    <>
      <Helmet>
        <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`}</script>
      </Helmet>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="gtm"
      />
    </>
  );
};

export default GTM;
